import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import WelcomeHeader from '../WelcomeHeader';
import blurredBackground from './assets/img/background-blurred.jpg';
import erisLogo from './assets/img/eris.svg';
import './styles.scss';

interface CourtesyPageProps {
	messageID: string
}

const CourtesyPage: React.FC<CourtesyPageProps> = (props) => {

	const { messageID } = props;

	return (
		<div
			className="CourtesyPage"
			style={{ backgroundImage: `url(${blurredBackground})` }}
		>
			<WelcomeHeader />
			<div className="CourtesyPage-content">
				<div className="CourtesyPageMessage">
					<div className="CourtesyPageMessage-header">
						<img className="CourtesyPageMessage-logo" src={erisLogo} alt="Eris" />
						<h2 className="CourtesyPageMessage-title">Business simulation</h2>
					</div>
					<div className={'CourtesyPageMessage-body'}>
						<div>
							<FormattedHTMLMessage id={`${messageID}-courtesy-page`} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


export default CourtesyPage;
